import { useBizMutation, useBizQuery } from '../Hooks/useBizQuery';
import {
	StaffingAction,
	StaffingFilter,
	StaffingPage,
	StaffingPerson,
	StaffingResult,
	StaffingRow,
	StaffingUser,
} from '../Types/staffing';
import { get, post } from './common';

const endpoint = 'api/eventstaffing';
export const useStaffing = (filter: StaffingFilter, enabled = true) =>
	useBizQuery(['STAFFING', 'list', filter], () => post<StaffingPage>(`${endpoint}/List`, filter), enabled);
export const useStaffingDetail = (id: number) =>
	useBizQuery(['STAFFING', 'detail', id], () => get<StaffingRow>(`${endpoint}/Detail?id=${id}`), id > 0);
export const getStaffingPeople = (filter: StaffingFilter) =>
	post<{ items: StaffingPerson[]; total: number; roles: { id: number; name: string }[] }>(`${endpoint}/People`, filter);
export const useStaffingPeople = (filter: StaffingFilter) =>
	useBizQuery(['STAFFING', 'people', filter], () => getStaffingPeople(filter));
export const useStaffingCandidates = (eventId: number, userId: number) =>
	useBizQuery(
		['STAFFING', 'candidates', eventId, userId],
		() => get<{ user: StaffingUser; error: string | null }[]>(`${endpoint}/Candidates?eventId=${eventId}&userId=${userId}`),
		eventId > 0
	);
export const useStaffingAction = () =>
	useBizMutation((actions: StaffingAction[]) => post<StaffingResult[]>(`${endpoint}/Apply`, actions), {
		getQueryKeyForInvalidation: () => [['STAFFING'], ['UPCOMING_EVENTS'], ['ONE_EVENT'], ['ONE_EVENT_FOR_ADMIN']],
	});

export const getPersonalStaffingCalendar = (from: string, to: string) =>
	post<
		{
			id: number;
			name: string;
			start: string;
			end: string;
			isCancelled: boolean;
			isSubstitute: boolean;
			mine: boolean;
			absent: boolean;
			canJoin: boolean;
			showInOverview: boolean;
		}[]
	>('api/eventstaffingcalendar/List', {
		from,
		to,
	});

export const useStaffingLeaveQueue = (filter: StaffingFilter, enabled: boolean) =>
	useBizQuery(
		['STAFFING', 'leaveQueue', filter],
		() =>
			post<{
				total: number;
				items: {
					user: StaffingUser;
					leaves: { id: number; date: string; approved: boolean }[];
					unresolved: number;
					projectedShortage: number;
					eventCount: number;
					shifts: Pick<StaffingRow, 'id' | 'name' | 'start' | 'end' | 'projected' | 'required' | 'missingRegular'>[];
					nextEvent?: string;
				}[];
			}>(`${endpoint}/LeaveQueue`, filter),
		enabled
	);

export const useStaffingPersonShifts = (userId: number, page: number) =>
	useBizQuery(
		['STAFFING', 'personShifts', userId, page],
		() =>
			get<{ total: number; items: { id: number; name: string; start: string; end: string }[] }>(
				`${endpoint}/PersonShifts?userId=${userId}&page=${page}`
			),
		userId > 0
	);
